/**
 * Le choix de la deuxième sécurité se propose une fois par connexion. En Mix,
 * chaque passage Bâtiment ↔ Magasin réémet la session de l'autre société et
 * recharge la page : l'écran revenait à chaque bascule. Le souvenir tient
 * dans l'onglet (il survit au rechargement) et s'efface à la déconnexion.
 */
const CLE_SECURITE_PROPOSEE = 'st_securite_proposee';

/**
 * @param {string|number|null|undefined} personne e-mail (ou id) du compte
 * @returns {boolean} vrai si le choix lui a déjà été proposé dans cet onglet
 */
export function securiteDejaProposee(personne) {
  if (personne == null) return false;
  try {
    return sessionStorage.getItem(CLE_SECURITE_PROPOSEE) === String(personne);
  } catch {
    // Stockage indisponible : le choix se propose, comme avant.
    return false;
  }
}

/** @param {string|number} personne e-mail (ou id) du compte à qui le choix vient d'être proposé */
export function noteSecuriteProposee(personne) {
  try {
    sessionStorage.setItem(CLE_SECURITE_PROPOSEE, String(personne));
  } catch {
    // Stockage indisponible : le choix reviendra à la prochaine bascule.
  }
}

/** Oublie le choix proposé : la connexion suivante le propose à nouveau. */
export function oublieSecuriteProposee() {
  try {
    sessionStorage.removeItem(CLE_SECURITE_PROPOSEE);
  } catch {
    // Stockage indisponible : rien à oublier.
  }
}
